<template>
  <div>
    <b-form novalidate @submit.stop.prevent="inviteUser">
      <b-form-row>
        <b-col>
          <b-form-group
            id="first-name-input-group"
            :label="$t('inviteUser.firstNameLabel')"
            label-for="first-name-input"
          >
            <b-form-input
              autocomplete="off"
              type="text"
              id="first-name-input"
              name="first-name"
              v-model="firstName"
              v-validate="{required: true}"
              :state="validateState('first-name')"
            ></b-form-input>

            <b-form-invalid-feedback>
              {{$t('inviteUser.firstNameInvalid')}}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="last-name-input-group"
            :label="$t('inviteUser.lastNameLabel')"
            label-for="last-name-input"
          >
            <b-form-input
              autocomplete="off"
              type="text"
              id="last-name-input"
              name="last-name"
              v-model="lastName"
              v-validate="{required: true}"
              :state="validateState('last-name')"
            ></b-form-input>

            <b-form-invalid-feedback>
              {{$t('inviteUser.lastNameInvalid')}}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-group
        id="phone-number-input-group"
        :label="$t('inviteUser.phoneNumberLabel')"
        label-for="phone-number-input"
      >
        <b-form-input
          autocomplete="off"
          type="text"
          id="phone-number-input"
          name="phone"
          v-model="phoneNumber"
          v-validate="{required: false}"
          :state="validateState('phone')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('inviteUser.phoneNumberInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="email-input-group"
        :label="$t('inviteUser.emailLabel')"
        label-for="email-input"
      >
        <b-form-input
          autocomplete="off"
          type="email"
          id="email-input"
          name="email"
          v-model="email"
          v-validate="{required: true, email: true}"
          :state="validateState('email')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('inviteUser.emailInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="role-input-group"
        :label="$t('inviteUser.roleLabel')"
        label-for="role-input"
      >
        <b-form-select
          id="role-input"
          name="role"
          v-model="role"
        >
          <option value="Admin">{{$t('inviteUser.roleAdmin')}}</option>
          <option value="Member">{{$t('inviteUser.roleMember')}}</option>
          <option value="Guest">{{$t('inviteUser.roleGuest')}}</option>
        </b-form-select>
      </b-form-group>

      <b-row>
        <b-col>
          <loading-button
            :text="$t('inviteUser.btnText')"
            :loading-text="$t('inviteUser.btnLoadingText')"
            variant="primary"
            :loading=submitting
            type="submit"
            :disabled="veeErrors.any()"
          />
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
  import FormValidation from '../../mixins/FormValidation';
  import FormReset from '../../mixins/FormReset';

  export default {
    mixins: [FormValidation, FormReset],
    data() {
      return {
        submitting: false,
        email: '',
        phoneNumber: '',
        role: 'Member',
        firstName: '',
        lastName: '',
      };
    },
    methods: {
      inviteUser() {
        this.$validator.validateAll().then((result) => {
          if (!result) {
            return;
          }
          this.submitting = true;
          this.$store.dispatch('account/inviteUser', {
            email: this.email,
            phoneNumber: this.phoneNumber,
            role: this.role,
            firstName: this.firstName,
            lastName: this.lastName,
          }).then(() => {
            this.$toasted.success(this.$t('inviteUser.inviteSent', { name: this.firstName }));
            // Clear form
            this.clearForm();
          }).catch((err) => {
            let errorMessage = this.$t('inviteUser.inviteError', { name: this.firstName });
            if (err.response.status >= 400 && err.response.status < 500) {
              errorMessage = err.response.data.message;
            }
            this.$toasted.error(errorMessage);
          }).finally(() => {
            this.submitting = false;
          });
        });
      },
      clearForm() {
        this.email = '';
        this.phoneNumber = '';
        this.role = 'Member';
        this.firstName = '';
        this.lastName = '';
        this.resetForm();
      },
    },
  };
</script>
